export default {
  methods: {
    updateFloorNumber(location_data, callback) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      var dialog;

      if (location_data['country_code'] != window.country) {
        dialog = self.$app.dialog.prompt("Adding <strong>" + location_data['location_name'] + "</strong> -" + " <strong>" + location_data['location_code'] + "</strong> in <strong>" + location_data['country'] + "</strong> to your account.<br/><br/>" + (location_data['new_country'] ? "You will be able to switch between locations of different countries from <strong>My Mitsu</strong> page.<br/><br/>" : "") + "Please enter your <u>floor number</u><small>(optional)</small> to proceed", function (floor_number) {
          console.log(floor_number);
          callback(floor_number);
        });
      } else {
        dialog = self.$app.dialog.prompt("Adding <strong>" + location_data['location_name'] + "</strong> -" + " <strong>" + location_data['location_code'] + "</strong> to your account.<br/>" + "Please enter your <u>floor number</u> (optional)", function (floor_number) {
          console.log(floor_number);
          callback(floor_number);
        });
      } //$$("input", dialog.el).attr("type", "number");


      $$("input", dialog.el).trigger("change");
      $$(".dialog-button:first-child", dialog.el).addClass("color-red").text("Cancel");
      $$(".dialog-button:last-child", dialog.el).text("Skip");
      $$("input", dialog.el).on("keyup", function (e) {
        console.log(e);
        var val = $$(e.target).val();

        if (val.trim().length > 0) {
          $$(".dialog-button:last-child", dialog.el).text("Add");
        } else {
          $$(".dialog-button:last-child", dialog.el).text("Skip");
        }
      });
      console.log(dialog);
    },

    sendAddLocation: function (data) {
      var self = this;
      self.verifyCodeIsValid(data, location_data => {
        self.updateFloorNumber(location_data, floor_number => {
          data['floor_number'] = floor_number;
          data['country_code'] = location_data['country_code'];
          self.$app.request({
            url: Url.to("location/add"),
            method: "POST",
            data: data,
            success: function (data, status, xhr) {
              console.log(data, status, xhr);
              self.$app.dialog.alert(data['message'], function () {
                window.switchToCountry(location_data['country_code']);
                self.$router.back("/my-mitsu/", {
                  force: true
                }); //location.reload();
              });
            }
          });
        });
      });
    },
    verifyCodeIsValid: function (data, callback) {
      var self = this;
      self.$app.request({
        url: Url.to("location/check-qr-multi-db"),
        method: "POST",
        data: data,
        success: function (data, status, xhr) {
          console.log(data, status, xhr);
          callback(data);
        }
      });
    },
    addLocation: function () {
      var self = this;
      var data = self.$app.form.convertToData("#location_code_form");
      self.sendAddLocation(data);
    },
    scanBarcode: function () {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;

      if (window.cordova) {
        cordova.plugins.barcodeScanner.scan(function (result) {
          console.log("We got a barcode\n" + "Result: " + result.text + "\n" + "Format: " + result.format + "\n" + "Cancelled: " + result.cancelled);
          var scannedLink = result.text;

          if (scannedLink) {
            var url = new URL(scannedLink);
            var scannedCode = url.searchParams.get("join");
            console.log("CODE", scannedCode);
            self.sendAddLocation({
              'location_code': scannedCode
            });
          } else {
            app.dialog.alert('Invalid barcode scanned, make sure to scan QR code found on the invitation card.');
          }
        }, function (error) {
          console.log("Scanning failed: " + error);
        }, {
          preferFrontCamera: false,
          // iOS and Android
          showFlipCameraButton: false,
          // iOS and Android
          showTorchButton: true,
          // iOS and Android
          torchOn: false,
          // Android, launch with the torch switched on (if available)
          saveHistory: true,
          // Android, save scan history (default false)
          prompt: "Place a barcode inside the scan area",
          // Android
          resultDisplayDuration: 500 // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
          //formats: "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
          //orientation: "landscape", // Android only (portrait|landscape), default unset so it rotates with the device
          //disableAnimations: true, // iOS
          //disableSuccessBeep: false // iOS and Android

        });
      } else {
        var scannedCode = prompt("code");
        self.sendAddLocation({
          'location_code': scannedCode
        });
      }
    }
  },
  id: 'bf163b8f82',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page no-toolbar navbar-extra-large" data-name="add-location">\n        <div class="navbar navbar-large navbar-extra-large">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a class="link back icon-only" href="#">\n                        <i class="icon icon-back"></i>\n                        <!--                        <span class="if-not-md">Back</span>-->\n                    </a>\n                </div>\n                <div class="title">Add Location</div>\n                <div class="right">\n                </div>\n                <div class="title-large">\n                    <div class="title-large-text">\n                        Location\n                        <div class="subtitle-text">Add new location</div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class="page-content">\n            <div class="list margin-top-half no-hairlines hide-webapp">\n                <ul>\n                    <li>\n                        <div class="block padding-horizontal text-align-center" style="white-space:normal">\n                           Please scan the <span class="text-color-primary">QR code</span>\n                            located on the invitation card that you received from Mitsulift.\n                            <br/>\n                            <br/>\n                            Once you have scanned the QR code, the location will be added to your account\n                        </div>\n                        <div class="scan-code-bg">\n\n                        </div>\n                        <div class="block-title padding-horizontal" style="white-space:normal">\n\n                        </div>\n                        <div class="block" style="padding: 0 35px">\n                            <button class="button button-large button-fill" @click="scanBarcode()">\n                                SCAN\n                            </button>\n                        </div>\n                    </li>\n                </ul>\n            </div>\n\n            <div class="block padding-horizontal text-align-center show-webapp" style="white-space:normal">\n                Please enter the invitation code that you received from Mitsulift.\n                <br/>\n                <br/>\n                Once you have entered the invitation code, the location will be added to your account\n            </div>\n            <div class="list no-hairlines no-hairlines-between show-webapp" id="location_code_form">\n                <ul>\n                    <li class="item-content item-input item-input-outline">\n                        <div class="item-inner">\n                            <div class="item-title item-label">Invite Code</div>\n                            <div class="item-input-wrap">\n                                <input name="location_code" placeholder="Invite Code" type="text">\n                                <span class="input-clear-button"></span>\n                            </div>\n                        </div>\n                    </li>\n                    <li class="item-content padding">\n                        <button @click="addLocation()" class="button button-large button-fill">\n                            Add\n                        </button>\n                    </li>\n                </ul>\n            </div>\n            <div class="display-none">\n                <div class="block-title padding-horizontal" style="white-space:normal">Scan the invite QR code\n                    received-<br/>or type in invite\n                    code if you have one\n                </div>\n                <br/>\n                <div class="block text-align-center">\n                    <a @click="scanBarcode()" class="link icon-only" href="#">\n                        <i class="icon f7-icons" style="font-size: 180px">qrcode_viewfinder</i>\n                    </a>\n                </div>\n                <div class="block">\n                    <button @click="scanBarcode()" class="button button-large button-fill">\n                        SCAN\n                    </button>\n                </div>\n                <div class="list no-hairline-top margin-top-half display-none-" id="location_code_form-">\n                    <ul>\n\n                        <li class="item-content item-input">\n                            <div class="item-inner">\n                                <div class="item-title item-label">Invite Code</div>\n                                <div class="item-input-wrap">\n                                    <input name="location_code" placeholder="Invite Code" type="text">\n                                    <span class="input-clear-button"></span>\n                                </div>\n                            </div>\n                        </li>\n                    </ul>\n                </div>\n                <div class="block display-none-">\n                    <button @click="addLocation()" class="button button-large button-fill">\n                        Add\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};